import { TableParams } from 'types/other';

export const DEFAULT_TABLE_PARAMS: TableParams = {
  page: 0,
  perPage: 10,
};
